import cn from 'classnames';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterSpecialtyTypes } from '../../actions/filters';
import { setSpecialtyTypes } from '../../actions/specialtyTypes/setSpecialtyTypes';
import { useFilterSpecialtyTypesSelector } from '../../hooks/selectors/useFilterSpecialtyTypesSelector';
import { FilterDropdown, OnCheckboxChange } from '../FilterDropdown';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterSpecialtyTypes.css';
import { useSpecialtyTypesIsLoadedSelector } from './internal/hooks/useSpecialtyTypesIsLoadedSelector';
import { useSpecialtyTypesItemsSelector } from './internal/hooks/useSpecialtyTypesItemsSelector';
import { IFilterSpecialtyTypesProps } from './types';

export const FilterSpecialtyTypes = memo<IFilterSpecialtyTypesProps>(function FilterSpecialtyTypes() {
  const dispatch = useDispatch();
  const filterSpecialtyTypes = useFilterSpecialtyTypesSelector();
  const specialtyTypesItems = useSpecialtyTypesItemsSelector();
  const specialtyTypesIsLoaded = useSpecialtyTypesIsLoadedSelector();

  useEffect(() => {
    if (!specialtyTypesIsLoaded) {
      dispatch(setSpecialtyTypes());
    }

    return () => {
      dispatch(setFilterSpecialtyTypes([]));
    };
    // Это эффект только маунта/демаунта компонента
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeFilterSpecialtyTypes = useCallback<OnCheckboxChange>(
    value => {
      dispatch(setFilterSpecialtyTypes(value));
    },
    [dispatch],
  );

  return (
    <div className={cn(stylesCommon['container'], styles['container'])}>
      <FilterDropdown
        checkboxGroups={specialtyTypesItems}
        checkboxValues={filterSpecialtyTypes}
        onCheckboxChange={handleChangeFilterSpecialtyTypes}
      />
    </div>
  );
});
